import { render, staticRenderFns } from "./headerIndex.vue?vue&type=template&id=2ffc3cb9"
import script from "./headerIndex.vue?vue&type=script&lang=js"
export * from "./headerIndex.vue?vue&type=script&lang=js"
import style0 from "./headerIndex.vue?vue&type=style&index=0&id=2ffc3cb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports